import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const TownNote = ({ t, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [v, setV] = useState(t.notes || "");
  const ref = useRef();
  useEffect(() => { if (!editing) setV(t.notes || ""); }, [t.notes, editing]);
  useEffect(() => { if (editing) ref.current?.focus(); }, [editing]);
  const save = async () => {
    setEditing(false);
    if (v.trim() === (t.notes || "")) return;
    try { const { data } = await api.put(`/towns/${t.id}/note`, { notes: v }); onSaved(t.id, data.notes); } catch (e) { toast.error(errMsg(e)); setV(t.notes || ""); }
  };
  if (editing) return (
    <input ref={ref} data-testid={`town-note-input-${t.id}`} value={v} maxLength={300} onChange={(e) => setV(e.target.value)} onBlur={save}
      onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); if (e.key === "Escape") { setV(t.notes || ""); setEditing(false); } }}
      placeholder="e.g. visited 2025, great markets" className="mt-1 w-full max-w-sm h-7 px-2 text-xs font-sans border border-[#C59B27] bg-white outline-none" />
  );
  return (
    <button data-testid={`town-note-${t.id}`} onClick={() => setEditing(true)} title="Private note"
      className={`block mt-0.5 text-left text-xs font-sans transition-colors ${t.notes ? "text-[#8C827A] italic hover:text-[#3B1B48]" : "text-[#C9BFB3] hover:text-[#C59B27]"}`}>
      {t.notes || "+ add note"}
    </button>
  );
};
